import { QuestionBarChart } from "@/web/routes/_protected/smb/-dashboard/-QuestionBarChart";
import { QuestionPieChart } from "@/web/routes/_protected/smb/-dashboard/-QuestionPieChart";
import type { SmbQuestionDetails } from "@/web/routes/_protected/smb/-dashboard/-types";

type QuestionDetailsContentProps = {
  details: SmbQuestionDetails;
};

export function QuestionDetailsContent({ details }: QuestionDetailsContentProps) {
  return (
    <div className="flex h-full min-h-0 flex-col">
      {details.chart?.type.tag === "Bar" ? <QuestionBarChart chart={details.chart} /> : null}
      {details.chart?.type.tag === "Pie" ? <QuestionPieChart chart={details.chart} /> : null}
    </div>
  );
}
